module.exports = __webpack_public_path__ + "img/08.a6c149d0.png";